<template>
  <div class="CheckoutFreeShippingProgressBar">
    <div class="mb-8 type-headline-sm mt-8">
      {{ freeShippingProgress < 1 ? $t('minicart.progressbar.left', {sum: useLocalizedCurrency(leftToFreeShipping)}): $t('minicart.progressbar.full') }}
    </div>
    <div class="h-4 w-full bg-light">
      <div
        class="h-full w-full !bg-bg-successStrong"
        :class="{
          'bg-light': freeShippingProgress === 1,
          '!bg-bg-successStrong': freeShippingProgress !== 1
        }"
        :style="`width: ${freeShippingProgress * 100}%`"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from '~/store/cart';
import { useGlobalContentStore } from '~/store/globalContent';
import { useLocalizedCurrency } from '~/composeables/useLocalizedCurrency';

const { $toNumber } = useNuxtApp();
const cartStore = useCartStore();
const globalContent = useGlobalContentStore();
const freeShippingBreakpoint = globalContent.getFreeShippingThreshold;

const totalPrice = computed(() => {
  return $toNumber(cartStore.cart.summary.priceBeforeVat) - $toNumber(cartStore.cart.summary.shippingBeforeVat);
});

const freeShippingProgress = computed(() => {
  return totalPrice.value < freeShippingBreakpoint ? totalPrice.value / freeShippingBreakpoint : 1;
});

const leftToFreeShipping = computed(() => {
  return freeShippingBreakpoint - totalPrice.value;
});

</script>
